import React from 'react'
import { SvgIconProps } from './Home'

const SvgScheduleIcon = ({ fill }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
  >
    <path
      fill={fill ?? "#353535"}
      d="M15.158 1.421h-.947V0H12.316V1.421H5.684V0H3.79V1.421h-.947C1.232 1.421 0 2.653 0 4.168v11.085C0 16.768 1.232 18 2.842 18h12.316C16.768 18 18 16.768 18 15.253V4.168c0-1.515-1.232-2.747-2.842-2.747zm.947 13.832a.95.95 0 01-.947.947H2.842c-.568 0-.947-.379-.947-.947V6.916h14.21v8.337zm0-10.137H1.895v-.948a.95.95 0 01.947-.947h.947v.947h1.895v-.947h6.632v.947H14.21v-.947h.948c.568 0 .947.379.947.947v.948z"
    ></path>
    <path
      fill={fill ?? "#353535"}
      d="M8.81 12.979H6.538l1.326-1.137c.474-.379.853-.853.853-1.8 0-1.232-.853-2.084-2.18-2.084-1.42 0-2.273.758-2.368 2.084v.19l1.8.189v-.19c0-.094.095-.568.569-.568.284 0 .474.095.474.379 0 .284-.19.474-.474.663l-2.463 2.18v1.704h4.642v-1.61h.095zM9.19 12.695c0 1.42 1.231 1.99 2.368 1.99 1.137 0 2.368-.664 2.368-1.99 0-.664-.284-1.137-.758-1.516.474-.284.664-.758.664-1.327 0-1.136-.853-1.894-2.274-1.894s-2.274.758-2.274 1.894c0 .569.284 1.043.663 1.327-.473.284-.758.852-.758 1.516zm2.368-2.274c-.284 0-.474-.19-.474-.474s.19-.473.474-.473.474.189.474.473c0 .38-.19.474-.474.474zm0 1.516c.379 0 .568.19.568.568 0 .284-.284.569-.568.569-.38 0-.569-.19-.569-.569-.094-.284.19-.568.569-.568z"
    ></path>
  </svg>
)

export default SvgScheduleIcon